import { useState, useEffect, useCallback } from "react";

export function useFetch<T>(
  apiCall: (payload?: any) => Promise<T>,
  defaultValue: T,
  initialPayload: any = {}
) {
  const [data, setData] = useState<T>(defaultValue);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [payload, setPayload] = useState(initialPayload);

  const fetchData = useCallback(
    async (pl: any = payload) => {
      setLoading(true);
      setError(null);
      try {
        const result = await apiCall(pl);
        setData(result);
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setLoading(false);
      }
    },
    [apiCall, payload]
  );

  // первичная загрузка
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // метод обновления с новым payload
  const update = useCallback(
    async (newPayload: any = {}) => {
      setPayload(newPayload);
      await fetchData(newPayload);
    },
    [fetchData]
  );

  return { data, loading, error, setData, update };
}
